import { z } from 'zod';

export const PlaceEmissionSequenceDocumentKinds = ['NFE', 'NFCE'] as const;

export const ListPlaceEmissionSequencesQuerySchema = z.looseObject({
  environment: z.enum(['HOMOLOGATION', 'PRODUCTION']).default('HOMOLOGATION'),
  series: z.literal('1').default('1'),
});
export type ListPlaceEmissionSequencesQuery = z.infer<typeof ListPlaceEmissionSequencesQuerySchema>;

export const PlaceEmissionSequenceItemSchema = z.looseObject({
  documentKind: z.enum(PlaceEmissionSequenceDocumentKinds),
  lastNumber: z.string().regex(/^\d+$/),
});

export const ListPlaceEmissionSequencesResponseSchema = z.looseObject({
  placeId: z.uuid(),
  environment: z.enum(['HOMOLOGATION', 'PRODUCTION']),
  series: z.string(),
  items: z.array(PlaceEmissionSequenceItemSchema),
});
export type ListPlaceEmissionSequencesResponse = z.infer<
  typeof ListPlaceEmissionSequencesResponseSchema
>;

export const AdvancePlaceEmissionSequenceBodySchema = z.looseObject({
  documentKind: z.enum(PlaceEmissionSequenceDocumentKinds),
  lastNumber: z.string().regex(/^\d+$/),
  environment: z.enum(['HOMOLOGATION', 'PRODUCTION']).default('HOMOLOGATION'),
  series: z.literal('1').default('1'),
});
export type AdvancePlaceEmissionSequenceBody = z.infer<
  typeof AdvancePlaceEmissionSequenceBodySchema
>;

export const AdvancePlaceEmissionSequenceResponseSchema = z.looseObject({
  placeId: z.uuid(),
  environment: z.enum(['HOMOLOGATION', 'PRODUCTION']),
  series: z.string(),
  documentKind: z.enum(PlaceEmissionSequenceDocumentKinds),
  lastNumber: z.string().regex(/^\d+$/),
});
export type AdvancePlaceEmissionSequenceResponse = z.infer<
  typeof AdvancePlaceEmissionSequenceResponseSchema
>;
